import {default as BackTop} from './backtop'

export default {
    BackTop
};